import {
  createApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
  configApiRef,
} from '@backstage/core-plugin-api';
import { ApiBlueprint } from '@backstage/frontend-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import LockOutlined from '@material-ui/icons/LockOutlined';

// No Keycloak-specific frontend API ref ships with Backstage (unlike
// githubAuthApiRef etc.) - the generic OAuth2 client is the documented
// way to talk to a generic OIDC provider (auth-backend-module-oidc-provider
// on the backend, see packages/backend/src/index.ts). provider.id below
// must match the app-config key (auth.providers.oidc).
export const oidcAuthApiRef = createApiRef<OAuth2>({
  id: 'auth.oidc',
});

export const oidcAuthApi = ApiBlueprint.make({
  name: 'oidc-auth',
  params: defineParams =>
    defineParams({
      api: oidcAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
        OAuth2.create({
          discoveryApi,
          oauthRequestApi,
          configApi,
          // OAuth2.create defaults this to 'development' if omitted -
          // confirmed by reading its actual source (GithubAuth.create
          // does the same, and also requires this to be passed
          // explicitly). Backend only configures auth.providers.oidc.production
          // (see release-backstage.yaml), so an unset/defaulted
          // 'development' env here 404s on /api/auth/oidc/start -
          // exactly what happened when this was first tested live.
          environment: configApi.getOptionalString('auth.environment'),
          provider: {
            id: 'oidc',
            title: 'Keycloak',
            icon: LockOutlined,
          },
        }),
    }),
});
